import {ITreeViewItemSourceData} from "../utils/TreeView";
import {IVanillaReaderUiAction, VanillaReaderUiActionNames} from "./VanillaReaderUiModel";

export const VanillaReaderUiActions: ITreeViewItemSourceData<IVanillaReaderUiAction | undefined>[] = [
    {
        id: Date.now().toString(),
        textContent: 'Where am I?',
        data: {
            name: VanillaReaderUiActionNames.WHERE_AM_I
        },
        children: []
    },
    {
        id: Date.now().toString(),
        textContent: 'Open Table of Contents',
        data: {
            name: VanillaReaderUiActionNames.TOC_OPEN_DIALOG
        },
        children: []
    },
    // Navigation actions
    {
        id: Date.now().toString(),
        data: undefined,
        textContent: "Navigation actions",
        children: [
            {
                id: Date.now().toString(),
                textContent: 'Next book section',
                data: {
                    name: VanillaReaderUiActionNames.NAVIGATE_NEXT
                },
                children: [],
            },
            {
                id: Date.now().toString(),
                textContent: 'Previous book section',
                data: {
                    name: VanillaReaderUiActionNames.NAVIGATE_PREVIOUS
                },
                children: [],
            },
            {
                id: Date.now().toString(),
                textContent: 'Next heading',
                data: {
                    name: VanillaReaderUiActionNames.NAVIGATE_NEXT_HEADING
                },
                children: [],
            },
            {
                id: Date.now().toString(),
                textContent: 'Previous heading',
                data: {
                    name: VanillaReaderUiActionNames.NAVIGATE_PREVIOUS_HEADING
                },
                children: [],
            },
            {
                id: Date.now().toString(),
                textContent: 'Go to location number',
                data: {
                    name: VanillaReaderUiActionNames.GOTO_PAGE_DIALOG_OPEN
                },
                children: [],
            },
            {
                id: Date.now().toString(),
                textContent: 'Open navigation history',
                data: {
                    name: VanillaReaderUiActionNames.NAVIGATION_HISTORY_DIALOG_OPEN
                },
                children: [],
            },
        ],
    },
    // Highlighting actions
    {
        id: Date.now().toString(),
        data: undefined,
        textContent: "Highlight actions",
        children: [
            {
                id: Date.now().toString(),
                textContent: 'Highlight active paragraph',
                data: {
                    name: VanillaReaderUiActionNames.HIGHLIGHT_READING_POSITION
                },
                children: [],
            },
            {
                id: Date.now().toString(),
                textContent: 'Highlight clipboard contents',
                data: {
                    name: VanillaReaderUiActionNames.HIGHLIGHT_CLIPBOARD
                },
                children: [],
            },
            {
                id: Date.now().toString(),
                textContent: 'Show all highlights',
                data: {
                    name: VanillaReaderUiActionNames.HIGHLIGHT_OPEN_DIALOG_ALL
                },
                children: [],
            },
            {
                id: Date.now().toString(),
                textContent: 'Show active highlights',
                data: {
                    name: VanillaReaderUiActionNames.HIGHLIGHT_OPEN_DIALOG_ACTIVE
                },
                children: [],
            }
        ],
    },
    // Bookmarking actions
    {
        id: Date.now().toString(),
        data: undefined,
        textContent: "Bookmark actions",
        children: [
            {
                id: Date.now().toString(),
                textContent: 'Bookmark active paragraph',
                data: {
                    name: VanillaReaderUiActionNames.BOOKMARK_READING_POSITION
                },
                children: [],
            },
            {
                id: Date.now().toString(),
                textContent: 'Bookmark clipboard contents',
                data: {
                    name: VanillaReaderUiActionNames.BOOKMARK_CLIPBOARD
                },
                children: [],
            },
            {
                id: Date.now().toString(),
                textContent: 'Show all bookmarks',
                data: {
                    name: VanillaReaderUiActionNames.BOOKMARK_OPEN_DIALOG_ALL
                },
                children: [],
            },
            {
                id: Date.now().toString(),
                textContent: 'Show active bookmarks',
                data: {
                    name: VanillaReaderUiActionNames.BOOKMARK_OPEN_DIALOG_ACTIVE
                },
                children: [],
            }
        ],
    },
    // Search actions
    {
        textContent: 'Book search',
        children: [
            {
                textContent: 'Open search dialog',
                children: [],
                data: {
                    name: VanillaReaderUiActionNames.SEARCH_DIALOG_OPEN
                },
                id: Date.now().toString()
            },
            {
                textContent: 'Clear search',
                children: [],
                data: {
                    name: VanillaReaderUiActionNames.SEARCH_CLEAR
                },
                id: Date.now().toString()
            }
        ],
        data: undefined,
        id: Date.now().toString()
    },
    {
        id: Date.now().toString(),
        textContent: 'Exit to bookshelf',
        data: {
            name: VanillaReaderUiActionNames.BOOKSHELF_DIALOG_OPEN
        },
        children: [],
    },
];
